export default {
  name: 'RtTableColumn',
  props: {
    fixed: String | Boolean,
    autoFixed: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    }
  },
  render(h) {
    let classes = [];
    if (this.fixed) {
      classes.push('rt-fixed-column');
    }
    if (this.autoFixed) {
      classes.push(`rt-fixed-column rt-fixed-column-${this.className}`);
    }

    const options = {
      attrs: this.$attrs,
      props: Object.assign({}, this.$props, {
        className: classes.join(' ')
      })
    };
    if (this.$scopedSlots.default) {
      options.scopedSlots = {
        default: props =>
          this.$scopedSlots.default({
            row: props.row,
            $index: props.$index
          })
      };
    }
    return h('el-table-column', options, this.$slots.default);
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/table/rtTableColumn.js